module.exports = __webpack_public_path__ + "static/media/logo_PeersGroup.08838e82.png";